import { Box, Paper, Stack, Typography } from "@mui/material";
import type { FC, ReactNode } from "react";

interface OpportunityFormSectionProps {
  title: string;
  children?: ReactNode;
  description?: string;
}

export const OpportunityFormSection: FC<OpportunityFormSectionProps> = ({
  title,
  children,
  description,
}) => (
  <Paper
    elevation={0}
    className="opportunity-form-section"
    sx={{
      borderRadius: 2,
      border: "1px solid rgba(0, 0, 0, 0.08)",
      backgroundColor: "rgba(255, 255, 255, 0.85)",
      p: 2.5,
      width: "100%",
    }}
  >
    <Stack gap={2}>
      <Box>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 700, color: "#05204CF2" }}
        >
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {description}
          </Typography>
        )}
      </Box>
      {children && <Stack gap={1.5}>{children}</Stack>}
    </Stack>
  </Paper>
);
